import classNames from "classnames";
import type { ButtonProps } from "@mui/material";
import { AppIconButton } from "../../../../../shared/components/AppIconButton";
import { DotsIcon } from "../../../../../shared/icons/DotsIcon";
import styles from "../styles.module.css";

interface Props extends ButtonProps {
  className?: string;
}

export const SidebarMenuButton = ({ className, ...props }: Props) => {
  const cls = classNames(styles["button"], className);

  return (
    <AppIconButton className={cls} {...props}>
      <DotsIcon />
    </AppIconButton>
  );
};
